import React from "react";
import { Link } from "react-router-dom";

// Smooth arc underline for "Together." — like a bowl/smile shape
const CurvedUnderline = () => (
  <svg
    viewBox="0 0 300 22"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full"
    style={{ marginTop: "2px", display: "block" }}
    preserveAspectRatio="none"
  >
    <path
      d="M 5 20 Q 150 4 295 20"
      stroke="#1167D0"
      strokeWidth="5"
      fill="none"
      strokeLinecap="round"
      opacity="0.85"
    />
  </svg>
);


const Herosection = () => {
  const handleDownload = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent) || /Windows/i.test(userAgent)) {
      window.plausible("Play Store Click");
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";
    } else if (/iPad|iPhone|iPod|ios/.test(userAgent) && !window.MSStream) {
      window.plausible("App Store Click");
      window.location.href =
        "https://apps.apple.com/us/app/social-spectrum/id6473112455";
    } else {
      window.plausible("Play Store Click");
      window.open(
        "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile",
        "_blank"
      );
    }
  };

  return (
    <div className="w-full bg-white">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-12 md:py-20 flex flex-col md:flex-row items-center gap-12 md:gap-8">

        {/* ── Left Content ── */}
        <div className="w-full md:w-1/2 flex flex-col items-start gap-6">

          {/* Pill badge */}
          <div
            className="flex items-center gap-2 px-4 py-2 rounded-full border"
            style={{
              width: "fit-content",
              borderColor: "#C8DCF5",
              background: "#EBF3FC",
            }}
          >
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1L10 6H15L11 9.5L12.5 14.5L8 11.5L3.5 14.5L5 9.5L1 6H6L8 1Z" fill="#1167D0" />
            </svg>
            <span className="text-[14px] font-[600] font-nunito" style={{ color: "#1167D0" }}>
              A warm, inclusive community
            </span>
          </div>

          {/* Heading */}
          <div>
            <h1
              className="text-[38px] md:text-[58px] leading-[1.15] font-[800] text-[#0D121F] font-quicksand text-left"
            >
              Navigating
              <br />
              Neurodiversity
              <br />
              <span className="relative inline-flex flex-col" style={{ color: "#1167D0" }}>
                Together.
                <CurvedUnderline />
              </span>
            </h1>
          </div>

          {/* Subtext */}
          <p className="text-[16px] text-[#5A6276] leading-[1.75] max-w-[440px] font-nunito text-left">
            Where neurodivergence finds its village. Join a compassionate
            community, access expert resources, and build meaningful
            connections—all in one app.
          </p>

          {/* Buttons */}
          <div className="flex items-center gap-4 flex-wrap justify-start">
            <button
              onClick={handleDownload}
              id="hero-download-btn"
              className="flex items-center gap-2 py-[13px] px-7 text-white text-[15px] font-[700] rounded-[32px] font-nunito"
              style={{
                background: "#1167D0",
                boxShadow: "0 4px 16px rgba(17, 103, 208, 0.35)",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.06)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(17, 103, 208, 0.45)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 16px rgba(17, 103, 208, 0.35)";
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16L7 11H10V4H14V11H17L12 16Z" fill="white" />
                <path d="M5 20H19V18H5V20Z" fill="white" />
              </svg>
              Download Now →
            </button>

            <Link
              to="/ourapp"
              id="hero-know-more-btn"
              className="py-[13px] px-7 text-[#0D121F] text-[15px] font-[600] rounded-[32px] font-nunito"
              style={{
                border: "1.5px solid #C8CDD8",
                transition: "transform 0.2s ease, border-color 0.2s ease, color 0.2s ease",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.04)";
                e.currentTarget.style.borderColor = "#1167D0";
                e.currentTarget.style.color = "#1167D0";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.borderColor = "#C8CDD8";
                e.currentTarget.style.color = "#0D121F";
              }}
            >
              Know More
            </Link>
          </div>
        </div>

        {/* ── Right Image ── */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-end relative">
          <div className="relative w-full max-w-[500px]">
            {/* Image card with soft blue frame */}
            <div
              className="w-full rounded-[28px] overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #C8DCF5 0%, #A0C4ED 100%)",
                padding: "10px",
                boxShadow: "0 20px 60px rgba(17, 103, 208, 0.15)",
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/images/aboutus/aboutmobilebg.webp"}
                alt="Happy families navigating neurodiversity together"
                className="w-full h-[320px] md:h-[400px] object-cover rounded-[20px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Herosection;
